import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { forkJoin, Subscription } from 'rxjs';
import { LifestyleService } from 'src/app/services/ha-new/lifestyle.service';
import { SpinnerComponent } from 'src/app/modules/shared/spinner/spinner.component';
import { ActivatedRoute } from '@angular/router';
import { LookupService } from 'src/app/services/ha-new/lookup.service';
import { NewHAService } from 'src/app/services/ha-new/new-ha.service';
import { MatDialog } from '@angular/material/dialog';
import { FullOverlayComponent } from 'src/app/modules/shared/ehe-modal/full-overlay/full-overlay.component';
import { AnalyticsBean } from 'src/app/beans/analytics/analytics-module.bean';

@Component({
	selector: 'app-safety',
	templateUrl: './safety.component.html',
	styleUrls: ['./safety.component.scss'],
})
export class SafetyComponent implements OnInit {
	/** Data carrier subscriptions */
	subscriptions: Subscription[] = [];
	/** holds ha id */
	healthAssessmentID: number = 0;
	/** holds appointment id */
	apptID: any;
	/** holds readOnly flag */
	readOnly: boolean = false;
	safetyData: any;
	safetyLookup = [];
	safetyForm: FormGroup;
	scrollTo = '';
	safetySlider: any = {
		showTicks: true,
		step: 1,
		tickInterval: 1,
	};
	/** Analytics bean */
	analyticsData: AnalyticsBean;
	returningUser: boolean = false;
	constructor(
		private lifestyleService: LifestyleService,
		private spinner: SpinnerComponent,
		private activatedRoute: ActivatedRoute,
		private lookupService: LookupService,
		private haService: NewHAService,
		private dialog: MatDialog
	) {
		this.analyticsData = new AnalyticsBean();
		this.activatedRoute.queryParams.subscribe(params => {
			//console.log('params:', params);
			this.apptID = params.apptID;
			this.readOnly = params.readOnly === 'true';
			this.healthAssessmentID = params.healthAssessmentID;
			this.returningUser = params.returningUser === 'true';
			if (this.scrollTo != 'false') {
				this.scrollTo = params.section;
			}
		});
	}

	ngOnInit() {
		this.initializeSafetyForm();
		this.getLookup();
	}

	next() {
		if (this.returningUser) {
			this.analyticsData.componentName = 'ha-update-button';
			this.analyticsData.id = 'Update HA Info';
		} else {
			this.analyticsData.componentName = 'ha-save-button';
			this.analyticsData.id = 'Save HA Info';
		}
		this.analyticsData.pageUrl = '/assessment/info/(lifestyle:safety)';
		this.analyticsData.placement = 'Health Assessment';
		if (!this.readOnly) {
			if (this.safetyForm.valid) {
				this.saveSafety();
			}
		}
	}

	getLookup() {
		this.spinner.startLoader();
		forkJoin({
			safetyLookup: this.lookupService.safetyLookup(),
			safety: this.lifestyleService.getSafety(this.apptID, this.healthAssessmentID),
		}).subscribe(
			res => {
				this.safetyLookup = res.safetyLookup.data;
				this.safetyData = res.safety.data;
				this.safetySlider['max'] = this.safetyLookup.length;
				this.safetySlider['min'] = 1;
				this.safetySlider['loaded'] = true;

				if (this.safetyData.wearSunscreen) {
					this.safetyForm.controls.wearSunscreen.setValue(this.safetyData.wearSunscreen);
				}
				if (this.safetyData.goTanning) {
					this.safetyForm.controls.goTanning.setValue(this.safetyData.goTanning);
				}
				if (this.safetyData.wearSeatbelt) {
					this.safetyForm.controls.wearSeatbelt.setValue(this.safetyData.wearSeatbelt);
				}
				this.spinner.stopLoader();
				if (this.scrollTo != 'false') {
					if (this.haService.scrollView(this.scrollTo)) {
						this.scrollTo = 'false';
					}
				}
			},
			err => {
				this.spinner.stopLoader();
				console.log(err);
			}
		);
	}

	/**
	 * saves safety
	 */
	saveSafety() {
		const data = this.safetyForm.getRawValue();

		// Prepopulated value if available and the value has not been updated
		if (this.haService.isValidIndex(data.wearSunscreen)) {
			if (this.returningUser || (!this.returningUser && this.selectionMade('wearSunscreen'))) {
				// data.wearSunscreen = data.wearSunscreen;
			} else if (this.safetyData.wearSunscreen) {
				data.wearSunscreen = this.safetyData.wearSunscreen;
			} else {
				data.wearSunscreen = undefined;
			}
		} else {
			data.wearSunscreen = undefined;
		}
		if (this.haService.isValidIndex(data.goTanning)) {
			if (this.returningUser || (!this.returningUser && this.selectionMade('goTanning'))) {
				// data.goTanning = data.goTanning;
			} else if (this.safetyData.goTanning) {
				data.goTanning = this.safetyData.goTanning;
			} else {
				data.goTanning = undefined;
			}
		} else {
			data.goTanning = undefined;
		}
		if (this.haService.isValidIndex(data.wearSeatbelt)) {
			if (this.returningUser || (!this.returningUser && this.selectionMade('wearSeatbelt'))) {
				// data.wearSeatbelt = data.wearSeatbelt;
			} else if (this.safetyData.wearSeatbelt) {
				data.wearSeatbelt = this.safetyData.wearSeatbelt;
			} else {
				data.wearSeatbelt = undefined;
			}
		} else {
			data.wearSeatbelt = undefined;
		}

		this.spinner.startLoader();
		//console.log(data,'hsa')
		this.subscriptions.push(
			this.lifestyleService
				.saveSafety(this.apptID, {
					...data,
					healthAssessmentID: this.safetyData.healthAssessmentID,
				})
				.subscribe(
					res => {
						//console.log(res);
						// making final save call

						this.haService.markComplete(this.apptID, this.healthAssessmentID).subscribe(
							res => {
								//console.log(res);
								this.haService.redirect(
									[],
									[],
									[],
									this.apptID,
									this.healthAssessmentID,
									this.readOnly,
									'',
									this.returningUser,
									true
								);
								this.spinner.stopLoader();
								this.openFinishModal();
							},
							err => {
								//console.log(err);
								this.spinner.stopLoader();
							}
						);
					},
					err => {
						console.log(err);
						this.spinner.stopLoader();
					}
				)
		);
	}

	initializeSafetyForm() {
		this.safetyForm = new FormGroup({
			wearSunscreen: new FormControl(''),
			goTanning: new FormControl(''),
			wearSeatbelt: new FormControl(''),
		});
	}

	openFinishModal() {
		// Scrolling to top before showing modal
		window.scroll(0, 0);
		const dialogRef = this.dialog.open(FullOverlayComponent, {
			width: '750px',
			autoFocus: false,
			panelClass: 'ha-new',
		});
	}

	selectionMade(slider) {
		return this.safetyForm.get(slider).touched;
	}
}
